// import '../styles/sbs-player-1.0.0.min.css';
import { loadStyles } from '../styles';
import { EventManager, SbsPlayerGlobal } from './common';
import './components';
import './page';
import * as utils from './utils';
import { isMobile, isWebView } from './utils/navigator';
import { loadCookie, removeCookie } from './utils/cookie';
import {
  loadLocalStorage,
  saveLocalStorage,
  removeLocalStorage,
} from './utils/storage';
import { isVirtualChannel, importScript } from './utils';
import { getAppLink } from './utils/deeplink';
import { isIOS, isAndroid } from './utils/navigator';
import SbsLogModule from './logic/SbsLogModule';

customElements.define(
  'sbs-player',
  class extends HTMLElement {
    constructor() {
      super();

      this.attachShadow({ mode: 'open' });

      const uuid = utils.generateUUID();
      this.uuid = uuid;
      this.styled = false;
      this.options = null;
      this.width = null;
      this.height = null;

      this.view = {};
      this.state = {};
      this.media = null;
      this.resizing = null;
      this.possibleResizing = null;

      this.rscuse = loadLocalStorage(SbsPlayerGlobal.storage.sbsplayer_rscuse);
      SbsPlayerGlobal.events = new EventManager(this);
      SbsPlayerGlobal.view = this.shadowRoot;
      SbsPlayerGlobal.id.uuid = this.uuid;
      SbsPlayerGlobal.options.crossorigin = 'anonymous';
      SbsPlayerGlobal.options.hide_contorls_seconds = 3_500;
      SbsPlayerGlobal.options.toast_seconds = 3_000;

      SbsPlayerGlobal.logModule = new SbsLogModule();
    }

    /* 모니터링 할 속성 이름 */
    static get observedAttributes() {
      return [
        'app_name',
        'development',
        'mobile',
        'media',
        'target',
        'service',
        'start',
        'protocol',
        'crossorigin',
        'muted',
        'autoplay',
        'src',
        'poster',
        'allow_adblock',
        'noad',
        'a11y',
        'w',
        'h',
        'token',
        'controls',
        'hiddens',
        'type',
        'rscuse',
        'curationid',
        'programhome',
        'applink',
      ];
    }

    /**
     * 속성 중 하나가 추가/제거/변경
     * - 미디어, 플레이어 콘트롤 옵션 변경
     */
    async attributeChangedCallback(name, oldValue, newValue) {
      try {
        if (name === 'app_name' && oldValue !== newValue) {
          SbsPlayerGlobal.config.name = newValue;
        }
        if (name === 'development' && oldValue !== newValue) {
          SbsPlayerGlobal.development = newValue === 'true';
        }
        // TODO: 속성 줄 필요없이 U.A. 로 플레이어 내에서 분기처리함으로 삭제
        // if (name === 'mobile' && (oldValue !== newValue)) {
        //   SbsPlayerGlobal.state.is_mobile = true;
        // }
        if (name === 'media' && oldValue !== newValue) {
          SbsPlayerGlobal.vodmediaid = newValue;
          this.media = newValue;
        }
        if (name === 'target' && oldValue !== newValue) {
          SbsPlayerGlobal.target = newValue.toLowerCase();
        }
        if (name === 'src' && oldValue !== newValue) {
          SbsPlayerGlobal.src = newValue;
        }
        if (name === 'poster' && oldValue !== newValue) {
          SbsPlayerGlobal.poster = newValue;
        }
        // ! ~~allvod 에서 program 으로 사용~~ X 그렇게 볼 수 없음
        if (name === 'service' && oldValue !== newValue) {
          this.service = newValue;
        }
        // * 시작시점
        if (name === 'start' && oldValue !== newValue) {
          SbsPlayerGlobal.options.start = parseFloat(newValue);
        }
        if (name === 'protocol' && oldValue !== newValue) {
          SbsPlayerGlobal.options.protocol = newValue;
        }
        if (name === 'crossorigin' && oldValue !== newValue) {
          SbsPlayerGlobal.options.crossorigin = newValue;
        }
        if (name === 'muted' && oldValue !== newValue) {
          SbsPlayerGlobal.options.muted = true;
        }
        if (name === 'autoplay' && oldValue !== newValue) {
          SbsPlayerGlobal.options.autoplay =
            newValue === 'true' || newValue === true;
        }
        if (name === 'allow_adblock' && oldValue !== newValue) {
          SbsPlayerGlobal.options.allow_adblock = true;
        }
        if (name === 'noad' && oldValue !== newValue) {
          SbsPlayerGlobal.options.noad = true;
        }
        if (name === 'a11y' && oldValue !== newValue) {
          SbsPlayerGlobal.options.a11y = true;
        }
        if (name === 'w' && oldValue !== newValue) {
          this.width = newValue;
        }
        if (name === 'h' && oldValue !== newValue) {
          this.height = newValue;
        }
        if (name === 'token' && oldValue !== newValue) {
          this.token = newValue;
        }
        // ? info 내 config.controls 도 있고.. 설정하기 애매함, 대신 예외처리로 hiddens 시킬 콘트롤러 요구사항은 있음, 아래 hiddens 속성 추가
        if (name === 'controls' && oldValue !== newValue) {
          SbsPlayerGlobal.control.shows = newValue.split(',');
        }
        if (name === 'hiddens' && oldValue !== newValue) {
          SbsPlayerGlobal.control.hiddens = newValue.split(',');
        }
        if (name === 'rscuse' && oldValue !== newValue) {
          this.rscuse = newValue;
        }
        //allvod, allclip 에서 사용되는 type
        if (name === 'type' && oldValue !== newValue) {
          this.type = newValue;
          SbsPlayerGlobal.vodtype = newValue;
        }
        //allvod 에서 사용되는 curationid
        if (name === 'curationid' && oldValue !== newValue) {
          SbsPlayerGlobal.vodcurationid = newValue;
        }
        //allvod 에서 사용되는 programhome
        if (name === 'programhome' && oldValue !== newValue) {
          SbsPlayerGlobal.vodprogramhome = newValue;
        }
        //allvod 에서 curation-type
        if (name === 'curationtype' && oldValue !== newValue) {
          SbsPlayerGlobal.vodcurationtype = newValue;
        }
        if (name === 'applink' && oldValue !== newValue) {
          SbsPlayerGlobal.state.isUseAppLink = newValue === 'true';
        }
        // ko, en, ca
        if (name === 'language' && oldValue !== newValue) {
          SbsPlayerGlobal.language = newValue;
        }
      } catch (error) {
        console.log(error);
      }
    }

    /**
     * DOM에 추가, 렌더링
     * - ready: 준비만 영역 또는 로딩 표시
     */
    async connectedCallback() {
      try {
        // * 페이지에서 다른 콤퍼넌트들이 모두 렌덩링 된 이후에 동작하게큼 변경
        const onClickKeyboardGuide = () => {
          const guideLayer = document.querySelector('#keyboard_guide');
          if (guideLayer) {
            guideLayer.style.display =
              guideLayer.style.display === 'none' ? 'block' : 'none';
          }
        };

        const addKeyboardGuide = () => {
          const guideLayer = document.querySelector('#keyboard_guide');
          const skipNav = document.querySelector('#skip_nav');

          if (guideLayer && skipNav) {
            const guideLink = document.createElement('li');
            const anchor = document.createElement('a');

            anchor.href = '#keyboard_guide';
            anchor.textContent = '키보드 단축키 안내';
            anchor.onclick = (event) => {
              const targetElement = document.querySelector(
                event.target.getAttribute('href')
              );
              if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' });
              }
              onClickKeyboardGuide();
            };

            guideLink.appendChild(anchor);
            skipNav.appendChild(guideLink);
          }
        };
        // 다른 컴포넌트들이 모두 렌더링된 후에 키보드 가이드 추가
        setTimeout(() => {
          addKeyboardGuide();
        }, 1_000);

        this.possibleResizing = this.width && this.height;

        // ! mobile 속성 제거 -> 스크립트에서 체크후 활용
        // ! 모바일 에선 1분 미리보기만 제공함
        SbsPlayerGlobal.state.is_mobile = isMobile();

        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        const paramsDevelopment = params.get('development');
        if (paramsDevelopment === 'true') SbsPlayerGlobal.development = true;
        if (paramsDevelopment === 'false') SbsPlayerGlobal.development = false;
        // 도메인에 .developers. 또는 .cloud. 가 포함되면 개발로 간주
        if (
          window.location.hostname.includes('.developers.') ||
          window.location.hostname.includes('programs.cloud.')
        ) {
          SbsPlayerGlobal.development = true;
        }

        removeCookie('SBS_PLAYER_TID');

        // * webview체크로직 sbsmain 에서 이관 => 2024.01.17 황계선 차장님 메일확인
        if (isWebView() && SbsPlayerGlobal.target === 'live') {
          const pagePlayerWrapper =
            document.querySelector('.live_player_box') ||
            document.querySelector('.player_box_video') ||
            document.querySelector('.player_video_w');
          pagePlayerWrapper.style.display = 'none';
          return false;
        }

        this.ready();

        // ! For OMP
        if (SbsPlayerGlobal.src) {
          //SbsPlayerGlobal.options.autoplay = false;
          //this.renderIntro();

          this.render();

          const backward = SbsPlayerGlobal.view.querySelector(
            'sbs-player-center-backward'
          );
          const forward = SbsPlayerGlobal.view.querySelector(
            'sbs-player-center-forward'
          );
          const controls = SbsPlayerGlobal.view.querySelector(
            'sbs-player-controls'
          );
          const video = SbsPlayerGlobal.view.querySelector('video');

          backward.style.visibility = 'hidden';
          forward.style.visibility = 'hidden';
          controls.style.visibility = 'hidden';
          video.addEventListener('playing', () => {
            backward.style.visibility = 'visible';
            forward.style.visibility = 'visible';
            controls.style.visibility = 'visible';
          });
          return;
        }

        if (this.media) {
          // FIXME: 골프예외처리, 로그인 토큰
          // TODO: SBSGOLF_LOGIN_INFO 골프회원 체크로직 (클립..에서..)
          // * 골프 기존 로직
          // 클립(HTML5) 에서 API 광고시퀀스와 별개로 골드회원이 아닐 경우엔 네트워크 광고로 하드코딩 프리롤 1개
          const loginJWT =
            this.token ||
            (SbsPlayerGlobal.target.toUpperCase() === 'GOLF' ||
            window.location.hostname.indexOf('.golf.') > -1
              ? loadCookie('LOGIN_JWT_GOLF')
              : loadCookie('LOGIN_JWT'));
          SbsPlayerGlobal.token = loginJWT;

          if (
            SbsPlayerGlobal.target.toUpperCase() === 'GOLF' ||
            window.location.hostname.indexOf('.golf.') > -1
          ) {
            const golfMemberInfo = decodeURIComponent(
              loadCookie('SBSGOLF_LOGIN_INFO')
            );
            if (
              golfMemberInfo.length > 0 &&
              JSON.parse(golfMemberInfo).USER_TYPE === 'GD'
            ) {
              // * 골프(골드) 회원 일 경우 광고없음
              SbsPlayerGlobal.options.noad = true;
            }
          }

          this.service = SbsPlayerGlobal.state.is_mobile ? '' : this.service;
          console.log('loginJWT', loginJWT);

          // * 연속재생시 화질 이어보기 위한 파라미터 추가
          const response = await this.getInfo(
            this.type || this.target || SbsPlayerGlobal.target,
            this.media,
            loginJWT,
            this.service,
            this.rscuse
          );

          SbsPlayerGlobal.state.data =
            response.vod || response.clip || response.onair;

          const dataEvent = new CustomEvent('info-fetched', {
            detail: SbsPlayerGlobal.state.data,
          });
          this.dispatchEvent(dataEvent);

          const { info, config, login_info, source } =
            SbsPlayerGlobal.state.data;
          const infoType = response.onair
            ? 'onair'
            : info.type === undefined
            ? 'smr'
            : info.type.toLowerCase() === 'clip' || response.clip
            ? 'clip'
            : 'vod';

          SbsPlayerGlobal.infoType = infoType;

          // 2025-08-27 인증관련 화면 추가, 배포(2025-11-03)
          if (login_info.join_info?.auth_yn === 'N') {
            this.renderVideoEndedMemberNeedAuth();
            return false;
          }

          // ! 릴리즈 여부
          let isReleased =
            infoType === 'vod'
              ? info.service_yn === 'N' ||
                (info.service_yn === 'Y' &&
                  (source &&
                    source.mediasource &&
                    source.mediasource.mediaurl) === undefined)
              : true;
          if (
            info.service_yn === 'Y' &&
            source.mediasource &&
            source.mediasource.medianame
          )
            isReleased = true;
          if (!isReleased) {
            this.renderIntro();

            return false;
          }

          // ! smr(allclip) 예외처리
          if (!info.type && infoType) {
            info.type = infoType;
            SbsPlayerGlobal.state.data.info.type = infoType;
          }

          // * sbsplayer_rscuse
          // * S회원일 경우 변경된 화질정보 저장
          if (login_info.is_s_member) {
            saveLocalStorage(
              SbsPlayerGlobal.storage.sbsplayer_rscuse,
              this.rscuse
            );
          } else {
            removeLocalStorage(SbsPlayerGlobal.storage.sbsplayer_rscuse);
          }
          SbsPlayerGlobal.options.start = info.playduration;

          // 재생 불가 조건 체크
          const isPlayBlocked =
            info.service_yn === 'N' ||
            info.onair_yn === 'N' ||
            info.overseas_yn === 'N' ||
            info.required_login === 'Y';

          if (isPlayBlocked) {
            // 메시지 결정: 각 yn 필드에 따라 해당 텍스트 표시
            const message =
              (info.service_yn === 'N' && info.service_text) ||
              (info.onair_yn === 'N' && info.onair_text) ||
              (info.overseas_yn === 'N' && info.overseas_text) ||
              '데이터를 가져올 수 없습니다.';

            // 다이얼로그 HTML 결정
            let htmlDialog = '';

            if (login_info?.required_login === 'Y') {
              // 로그인 필요
              htmlDialog = `<em class='age19_title'>${message}</em>
                <p class='age19_text'>이용을 원하면 로그인 하세요.</p>
                <a href='#none' class='btn_login'>로그인</a>`;
            } else if (login_info?.join_info?.info_yn === 'N') {
              // 개인정보 등록 필요
              htmlDialog = `<p class='age19_text'>연령 확인을 위한 개인 정보를 등록해 주세요.</p>
                <a href='#none' class='btn_registInfo'>개인정보 등록하기</a>`;
            } else {
              // 기본 메시지
              htmlDialog = `<em class='age19_title'>${message}</em>`;
            }

            // UI 렌더링
            const playerWrap =
              SbsPlayerGlobal.view.querySelector('.playerWrap');

            if (info.targetage === 19) {
              const htmlIcon = `<span class='icon_19'><span class='iconSvg_19'><i class='hide'>19</i></span></span>`;
              playerWrap.innerHTML = `<sbs-player-dialog-age-19-type icon="${htmlIcon}" html="${htmlDialog}"></sbs-player-dialog-age-19-type>`;
            } else {
              playerWrap.innerHTML = `<sbs-player-warning title="재생불가" html="${message}"></sbs-player-warning>`;
            }
          } else {
            // 재생 가능한 경우: 에피소드 리스트 콘트롤 설정
            try {
              if (config?.control) {
                config.control.controlbar.button['episode'] =
                  this.service === 'program' ? 'Y' : 'N';
              }
            } catch (error) {
              console.warn(
                '* 에피소드 리스트 콘트롤 관련 예외처리, 온에어의 경우 API에 control 속성 없음',
                error
              );
            }

            this.renderIntro();

            // * 자동 재생 일 경우
            if (SbsPlayerGlobal.options.autoplay) {
              try {
                const triggerAutoplay = () => {
                  setTimeout(() => {
                    const introBtn = this.shadowRoot.querySelector(
                      'sbs-player-intro button'
                    );
                    if (introBtn) {
                      introBtn.click();
                    } else {
                      console.warn('Intro button not found for autoplay');
                    }
                  }, 500);
                };

                // HLS 스트림이고 Hls.js가 로드되지 않은 경우
                const needsHlsLibrary = typeof Hls === 'undefined';

                if (needsHlsLibrary) {
                  console.log(
                    'Loading Hls.js for autoplay:',
                    SbsPlayerGlobal.url.lib.hls
                  );
                  importScript(SbsPlayerGlobal.url.lib.hls, triggerAutoplay);
                } else {
                  triggerAutoplay();
                }
              } catch (error) {
                console.error('Autoplay initialization failed:', error);
              }
            }
          }

          this.event();
        } else {
          SbsPlayerGlobal.view.querySelector(
            '.playerWrap'
          ).innerHTML = `<sbs-player-warning title="재생오류" html="영상 정보를 가져오지 못했습니다."></sbs-player-warning>`;
        }
      } catch (error) {
        console.error(error);
        SbsPlayerGlobal.view.querySelector(
          '.playerWrap'
        ).innerHTML = `<sbs-player-warning title="재생오류" html="서버에 접속하지 못했습니다."></sbs-player-warning>`;
      }
    }

    /**
     * DOM에서 제거, 엘리먼트를 정리
     * - 로그 전송?
     */
    disconnectedCallback() {
      try {
        //console.log(`disconnectedCallback ${this.uuid}`);
      } catch (error) {
        console.log(error);
      }
    }

    /**
     * 다른 Document에서 옮겨짐
     *
     */
    adoptedCallback() {
      try {
      } catch (error) {
        console.log(error);
      }
    }
    static set data(data) {
      SbsPlayerGlobal.state.data = data;
    }
    static get data() {
      return SbsPlayerGlobal.state.data;
    }
    static get utils() {
      return utils;
    }

    ready() {
      try {
        const wrapperClassName = SbsPlayerGlobal.state.is_mobile
          ? 'playerWrap playerMobileType'
          : 'playerWrap';
        this.shadowRoot.innerHTML = `<div class="${wrapperClassName}" 
      ${
        SbsPlayerGlobal.poster
          ? `style="background-image: url(${SbsPlayerGlobal.poster});background-size: cover;"`
          : ''
      }>
      </div>`;

        this.styles();
        this.attribute();

        this.resize();
      } catch (error) {
        console.log(error);
      }
    }

    renderIntro() {
      try {
        const { info, source } = SbsPlayerGlobal.state.data;

        const posterImg =
          SbsPlayerGlobal.poster ||
          info.defaultimage ||
          (info.thumbs ? info.thumbs['640'] : null) ||
          info.thumbimg ||
          `https://program-image.cloud.sbs.co.kr/${source.channel}.jpg`;

        const mediaTitle = info ? info.title.replace(/['"]+/g, '') : '플레이어';
        this.shadowRoot.querySelector(
          '.playerWrap'
        ).innerHTML = `<sbs-player-intro image='${posterImg}' title='${mediaTitle}'></sbs-player-intro>`;

        let intro = this.shadowRoot.querySelector('sbs-player-intro');
        intro.addEventListener('button-click-intro', (event) => {
          utils.unmute();
          this.render();
        });
      } catch (error) {
        console.log(error);
      }
    }

    renderVideoEndedMembership() {
      try {
        this.shadowRoot.querySelector(
          '.playerWrap'
        ).innerHTML = `<sbs-player-membership></sbs-player-membership>`;
      } catch (error) {
        console.log(error);
      }
    }

    renderVideoEndedMemberNeedAuth() {
      try {
        this.shadowRoot.querySelector(
          '.playerWrap'
        ).innerHTML = `<sbs-player-member-need-auth></sbs-player-member-need-auth>`;
      } catch (error) {
        console.log(error);
      }
    }

    renderVideoEndedLivePreview() {
      try {
        if (
          this.shadowRoot.querySelector('sbs-player-dialog-live-preview-end')
        ) {
          return;
        }
        console.log('renderVideoEndedVodPreview');
        this.shadowRoot.querySelector(
          '.playerWrap'
        ).innerHTML = `<sbs-player-dialog-live-preview-end></sbs-player-dialog-live-preview-end>`;
      } catch (error) {
        console.log(error);
      }
    }

    renderVideoEndedVodPreview() {
      try {
        if (
          this.shadowRoot.querySelector('sbs-player-dialog-vod-preview-end')
        ) {
          return;
        }
        console.log('renderVideoEndedVodPreview');
        this.shadowRoot.querySelector(
          '.playerWrap'
        ).innerHTML = `<sbs-player-dialog-vod-preview-end></sbs-player-dialog-vod-preview-end>`;
      } catch (error) {
        console.log(error);
      }
    }

    renderEndClipListLayer() {
      try {
        const endClipList = this.shadowRoot
          .querySelector('.playerWrap')
          .querySelector('sbs-player-end-clip-list-layer');
        endClipList.style.display = 'block';
        endClipList.addEventListener('button-click-replay', (event) => {
          this.$video = SbsPlayerGlobal.view.querySelector(
            'sbs-player-wrapper video'
          );
          this.$video.currentTime = 0;
          this.$video.play();
        });
      } catch (error) {
        console.log(error);
      }
    }

    renderSimple() {
      try {
        this.shadowRoot.querySelector(
          '.playerWrap'
        ).innerHTML = `<sbs-player-wrapper></sbs-player-wrapper>`;
      } catch (error) {
        console.log(error);
      }
    }

    render() {
      try {
        const { info } = SbsPlayerGlobal.state.data;

        // 속성에 따라 광고, 콘텍스트메뉴, 쉐어, 플레이리스트 등 표시 하도록..
        this.shadowRoot.querySelector(
          '.playerWrap'
        ).innerHTML = `<sbs-player-container></sbs-player-container>
      <sbs-player-contextmenu></sbs-player-contextmenu>
      <sbs-player-loading></sbs-player-loading>
      ${
        SbsPlayerGlobal.target !== 'live'
          ? `<sbs-player-episode-list type="${SbsPlayerGlobal.vodtype}"></sbs-player-episode-list>`
          : ``
      }
      ${
        SbsPlayerGlobal.state.is_mobile &&
        info &&
        info.type.toUpperCase() === 'CLIP'
          ? `<sbs-player-end-clip-list-layer style="display: none;"></sbs-player-end-clip-list-layer>`
          : ``
      }
      `;

        this.styles();
        this.event();

        this.resize();
      } catch (error) {
        console.log(error);
      }
    }

    goAppLink() {
      try {
        const { info } = SbsPlayerGlobal.state.data;
        let channelId = info.channelid;
        let payType = 'N';
        let playType =
          SbsPlayerGlobal.target === 'live'
            ? 'live'
            : info.type.toUpperCase().includes('VOD')
            ? 'vod'
            : 'clip';

        document.location = getAppLink(channelId, payType, playType);
        if (isIOS()) {
          setTimeout(() => {
            document.location = 'https://itunes.apple.com/kr/app/id1020136055';
          }, 2_000);
        }
      } catch (error) {
        console.error(error);
      }
    }

    event() {
      try {
        const { info, ad, source } = SbsPlayerGlobal.state.data;

        const contextmenu = this.shadowRoot.querySelector(
          'sbs-player-contextmenu'
        );
        const playerWrapperElement =
          this.shadowRoot.querySelector('sbs-player-wrapper');
        const playerContainerElement = this.shadowRoot.querySelector(
          'sbs-player-container'
        );

        let url = new URL(SbsPlayerGlobal.url.share);
        let params = new URLSearchParams(url.search);
        if (SbsPlayerGlobal.development || this.development)
          params.append(
            'development',
            SbsPlayerGlobal.development || this.development
          );
        if (SbsPlayerGlobal.target || this.target)
          params.append('target', SbsPlayerGlobal.target || this.target);
        if (this.media) params.append('media', this.media);
        // url 로 안줘도 static.sbs.co.kr 쉐어 페이지에서 쿠키사용 가능
        //if (SbsPlayerGlobal.token || this.token) params.append('token', SbsPlayerGlobal.token || this.token);
        if (SbsPlayerGlobal.service || this.service)
          params.append('service', SbsPlayerGlobal.service || this.service);
        url.search = params.toString();

        const shareTitle =
          SbsPlayerGlobal.state.data.info.title || document.title;
        const shareURL = url.toString();

        const resizeObserver = new ResizeObserver(() => {
          const wrapper = this.shadowRoot.querySelector('.playerWrap'); // fullscreen
          if (wrapper) {
            this.resize();
            if (wrapper.offsetWidth >= 1920) {
              wrapper.classList.add('min1920Size');
            } else {
              wrapper.classList.remove('min1920Size');
            }
          }
        });
        resizeObserver.observe(this.shadowRoot.querySelector('.playerWrap'));

        this.addEventListener(
          'contextmenu',
          (event) => {
            event.preventDefault();
            if (contextmenu) contextmenu.pointerEvent = event;
          },
          false
        );
        this.addEventListener(
          'click',
          (event) => {
            if (contextmenu) contextmenu.pointerEvent = null;
          },
          false
        );
        playerContainerElement?.addEventListener('billing-popup', (event) => {
          event.preventDefault();
          const qcEvent = new CustomEvent('player-purchase', {
            detail: event.detail,
            bubbles: true,
            composed: true, // * shadow root 밖으로 이벤트 전파
          });
          this.dispatchEvent(qcEvent);
        });

        //  copied
        contextmenu?.addEventListener('button-click-url', (event) => {
          window.navigator.clipboard.writeText(window.location.href);
        });
        contextmenu?.addEventListener('button-click-code', (event) => {
          window.navigator.clipboard.writeText(
            `<iframe width="640" height="480" src="${shareURL}" title="${
              SbsPlayerGlobal.state.data.info.title || document.title
            }" frameborder="0"></iframe>`
          );
        });

        SbsPlayerGlobal.events.addEventListener(
          'button-click-popup',
          (event) => {
            window.open(
              shareURL,
              shareTitle,
              'width=640, height=360, resizable=yes, scrollbars=yes, menubar=no, toolbar=no, location=no'
            );
          }
        );

        // * 미리보기 종료
        let timerOnairPreview;
        SbsPlayerGlobal.events.addEventListener(
          'video-change-player',
          (event) => {
            if ('ended' === event.type) {
              event.preventDefault();

              // * 연속재생
              // 템플릿: 로컬스토리지, sbs-program-playlist-useContinuousPlay === 'true'
              // 템플릿 버그, 로컬스토리지에 값이 없어도 활성화 된것 처럼 보임
              // AllVOD(lagacy): 쿠키, VOD_AUTO_PLAY_CHECK === 'Y'
              let pageContinuePlayBackElement =
                document.querySelector('.epa_btn');
              let isContinuePlayBack =
                loadLocalStorage(
                  SbsPlayerGlobal.storage.sbsplayer_use_continuos_play
                ) === 'true' ||
                pageContinuePlayBackElement?.classList.contains('on') ||
                loadCookie('VOD_AUTO_PLAY_CHECK') === 'Y';
              const veEvent = new CustomEvent('player-ended', {
                detail: {
                  cont_playback: isContinuePlayBack,
                  media: this.media,
                  next_media: SbsPlayerGlobal.next_media_id,
                  rscuse: SbsPlayerGlobal.state.rscuse,
                },
                bubbles: true,
                composed: true, // * shadow root 밖으로 이벤트 전파
              });
              this.dispatchEvent(veEvent);

              if (
                info &&
                info.onair_preview_yn &&
                info.onair_preview_yn.toUpperCase() === 'Y'
              ) {
                // this.renderVideoEndedLivePreview();
                this.renderVideoEndedLivePreview();
                return false;
              }

              // * 모바일일 경우 구매 유도창 없음
              if (info && info.type && info.type.toUpperCase() === 'VOD3MIN') {
                //this.renderVideoEndedMembership();
                this.renderVideoEndedVodPreview();
                return false;
              }

              if (info && info.type && info.type.toUpperCase() === 'CLIP') {
                this.renderEndClipListLayer();
                return false;
              }
            }
            if (
              'play' === event.type &&
              (info.preview_yn === 'Y' || info.onair_preview_yn === 'Y')
            ) {
              clearTimeout(timerOnairPreview);
              timerOnairPreview = setTimeout(() => {
                try {
                  // FIXME: 골프예외처리, 온에어 프리뷰 종료
                  if (
                    SbsPlayerGlobal.target.toUpperCase() === 'GOLF' ||
                    window.location.hostname.indexOf('.golf.') > -1
                  ) {
                    sendToJS_Login();
                  } else {
                    SbsPlayerGlobal.target === 'live'
                      ? this.renderVideoEndedLivePreview()
                      : this.renderVideoEndedVodPreview();

                    SbsPlayerGlobal.logModule.contentPlayEnd();
                  }
                } catch (error) {
                  console.error(error);
                }
                //}, 5 * 1000);
              }, source.duration * 1000);
            }
          }
        );

        SbsPlayerGlobal.events.addEventListener('video-ended', () => {
          try {
            console.log('++ video-ended');
            if (
              info &&
              info.onair_preview_yn &&
              info.onair_preview_yn.toUpperCase() === 'Y'
            ) {
              this.renderVideoEndedLivePreview();
              return false;
            }
            if (
              info &&
              info.preview_yn &&
              info.preview_yn.toUpperCase() === 'Y'
            ) {
              this.renderVideoEndedVodPreview();
              return false;
            }
            if (info && info.type && info.type.toUpperCase() === 'CLIP') {
              this.renderEndClipListLayer();
              return false;
            }
          } catch (error) {
            console.log(error);
          }
        });

        SbsPlayerGlobal.events.addEventListener('applink-clicked', () => {
          try {
            this.goAppLink();
          } catch (error) {
            console.log(error);
          }
        });
      } catch (error) {
        console.log(error);
      }
    }

    attribute() {
      try {
        this.shadowRoot
          .querySelector('.playerWrap')
          .setAttribute('id', this.uuid);
      } catch (error) {
        console.log(error);
      }
    }

    resize() {
      try {
        if (this.possibleResizing) {
          clearTimeout(this.changeStyle);
          this.resizing = setTimeout(() => {
            const wrapper = this.shadowRoot.querySelector('.playerWrap');
            this.height =
              this.height === '100%' ||
              this.height === '0px' ||
              this.height === 'auto' ||
              this.height === ''
                ? wrapper.offsetWidth * 0.5625 + 'px'
                : this.height;
            wrapper.style.width = this.width;
            wrapper.style.height = this.height;

            this.height = '';
          }, 250);
        }
      } catch (error) {}
    }

    styles() {
      try {
        loadStyles(this);

        const styles = `
        .playerWrap sbs-player-ad-wrapper {
          visibility: hidden !important;
        }

        .playerADType sbs-player-ad-wrapper {
          visibility: visible !important;
        }

        .playerADType sbs-player-end-clip-list-layer {
          display: none !important;
        }
        `;

        const previousStyles = this.shadowRoot.querySelector(
          `#${this.uuid}-style`
        );
        if (previousStyles) {
          previousStyles.remove();
        }
        const attrStyles = document.createElement('style');
        attrStyles.setAttribute('id', this.uuid + '-style');

        attrStyles.textContent = styles;
        this.shadowRoot.appendChild(attrStyles);
      } catch (error) {
        console.log(error);
      }
    }

    // FIXME: info 호출시 파라미터 정리 필요

    /**
  * 
  * @param {string} target SBS, LIVE, LIVE_24TV, GOLF, NEWS
  * @param {string} id Media ID
  * @param {string} token jwt-token
  * @param {string} service program, 삭제예정
  * @param {string} rscuse 02, 05, 07 화질

  * @return {*} 
  */
    getInfo(target, id, token, service, rscuse) {
      try {
        target = target?.toUpperCase() ?? 'SBS';
        service ??= '';
        rscuse ??= '';

        // ! 가상채널 예외처리
        if (isVirtualChannel(id) && target === 'LIVE') {
          target = 'LIVE_24TV';
        }
        if (
          ['programs.sbs.co.kr', 'm.programs.sbs.co.kr'].includes(
            window.location.host
          )
        ) {
          service = 'program';
        }

        let apiUrl;
        console.log('target', target, SbsPlayerGlobal.development);
        switch (target) {
          case 'LIVE':
            apiUrl = `https://${
              SbsPlayerGlobal.development ? 'dev.' : ''
            }apis.sbs.co.kr/play-api/${
              window.location.hostname.indexOf('.golf.') > -1 ? 'golf/' : ''
            }1.0/onair/channel`;
            rscuse = '';
            break;
          case 'LIVE_24TV':
            apiUrl = `https://${
              SbsPlayerGlobal.development ? '' : ''
            }apis.sbs.co.kr/play-api/1.0/onair/binge-watch/channel`;
            rscuse = '';
            break;
          case 'SMR':
            SbsPlayerGlobal.options.protocol = 'download';
            apiUrl = `https://${
              SbsPlayerGlobal.development ? 'dev.' : ''
            }apis.sbs.co.kr/play-api/1.0/media`;
            break;
          case 'GOLF':
            apiUrl = `https://api.golf.${
              SbsPlayerGlobal.development ? 'developers.' : ''
            }sbs.co.kr/content/videos/player`;
            break;
          case 'NEWS':
            apiUrl = `https://${
              SbsPlayerGlobal.development ? 'dev.' : ''
            }apis.sbs.co.kr/play-api/1.0/sbs_newsmedia`;
            break;
          default:
            apiUrl = `https://${
              SbsPlayerGlobal.development ? 'dev.' : ''
            }apis.sbs.co.kr/play-api/1.0/sbs_vodall`;
            break;
        }

        const url = new URL(`${apiUrl}/${id}`);

        //url.protocol = `${SbsPlayerGlobal.development || process.env.NODE_ENV ? 'http:' : 'https:'}`;
        url.protocol = 'https:';
        url.searchParams.set('jwt-token', token);
        url.searchParams.set(
          'platform',
          SbsPlayerGlobal.state.is_mobile ? 'mobileweb' : 'pcweb'
        );
        // ! ~~service=program 여부에 따라 VOD3MIN, VODMALL_FULL_AD 나뉨~~ 무료/유료 프로그램에 따라 API 에서 나눠서 노출
        // ! ~~service=program 일 경우 ALLVOD라고 판단하면됨~~ (수정) ALLVOD로 판단할 수 없음
        // ! absolute_show=Y 운영자가 미리 회차를 편성하는 경우에 데이터 노출을 위해 사용 (플레이어 입장에선 고정)
        url.searchParams.set('service', service); // 어차피 API 에서 삭제 예정
        url.searchParams.set('absolute_show', service ? 'Y' : '');
        url.searchParams.set('ssl', 'Y');
        //url.searchParams.set('rscuse', this.type.toLowerCase().indexOf('allvod') > -1 ? '05' : '');
        url.searchParams.set('rscuse', rscuse);
        url.searchParams.set(
          'protocol',
          SbsPlayerGlobal.options.streaming
            ? SbsPlayerGlobal.options.streaming
            : 'hls'
        ); // hls, download

        // * LIVE(v_type=2&platform=pcweb&protocol=hls&ssl=Y&rscuse=&extra=)
        if (target.toUpperCase().indexOf('LIVE') > -1) {
          url.searchParams.set('v_type', '2');
          // * Golf 예외처리 - VOD 중 HLS 스트리밍으로 재생이 안되는 경우 발생 [hls → mp4streaming 으로 변경(2023/04/14)]
          url.searchParams.set('extra', '');
        }

        SbsPlayerGlobal.url.info = url;

        let fetchOptions = {};
        if (document.cookie === '') {
          fetchOptions = {
            method: 'GET',
          };
        } else {
          fetchOptions = {
            method: 'GET',
            credentials: 'include',
          };
        }

        const response = fetch(`${url}`, fetchOptions);

        return response.then((res) => res.json());
      } catch (error) {
        return null;
      }
    }
  }
);
